import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Contact } from '../../../../../../generated/generated-types';
import { ContactHeaderCardWidgetComponent } from '../contact-header-card-widget.component';

@Component({
  selector: 'app-formly-contact-header-card-widget',
  templateUrl: './formly-contact-header-card-widget.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ContactHeaderCardWidgetComponent
  ]
})
export class FormlyContactHeaderCardWidgetComponent extends FieldType {


  async onAssetChoose(resolveCallback: () => Promise<void>) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    //first save existing contact
    if (detailComponent && detailModel && detailComponent.modelIsDirtySig())
      await detailComponent.save(detailModel, null, true);

    // After save is complete, call the callback to let the child component continue
    await resolveCallback();
  }

  async onContactChanged(contact: Contact) {
    const { detailComponent, detailModel } = this.getDetailComponentAndModel();
    if (detailComponent && detailModel) {
      // In this merge step, detailModel.contact was overwritten contact, witch i think is not correct, since what comes from the parameter is the most updated contact.
      // So we need here to update from the contact to the detailModel.contact.
      // Well, since i did it, on my last step of test, by this mistake, it might be that more other logics could be avoided in different places.
      let contactOfDetailComponent = { ...contact, ...detailModel.contact };
      detailModel.contact = contactOfDetailComponent;
      await detailComponent.setModel(detailModel);
    }
  }

  getDetailComponentAndModel() {
    const detailComponent = this.options?.formState?.detailComponent;
    if (detailComponent?.detailModelSig()) {
      let detailModel = detailComponent.detailModelSig();
      return { detailComponent, detailModel };
    }
    return { detailComponent, detailModel: null };
  }

}
